import React from 'react';
import { Input } from '../../../../../components/Input/index';
import './externalProviderCard.css';

const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const ExternalProviderCard = (props) => {
  let companyNameValidationMessages = null;

  if (props.validationMessages[props.externalITProvider._id + '_companyName']) {
    companyNameValidationMessages = props.validationMessages[props.externalITProvider._id + '_companyName'].map(message => {
      message = message.toString().replace(/ /g, '-').replace(capitalize(props.externalITProvider._id.toString()), '');
      message = message.replace(/-/g, ' ').trim();
      message = capitalize(message);
      return message;
    });
  }

  return (
    <div className="container company-external-provider-card">
      <div className="row card-title">
        <div className="col-10">
          <p>{props.titleCard} {props.index + 1}</p>
        </div>
        <div className="col-2">
          <button type="button" className="close" aria-label="Close" onClick={props.onClickClose}>
            <span aria-hidden="true" id={props.externalITProvider._id}>&times;</span>
          </button>
        </div>
      </div>

      <div className="row">
        <div className="col-12 content-input">
          <Input
            labelName={props.labelCompanyName}
            inputStyle="input-card"
            labelStyle="label-input-company"
            placeHolder={props.placeHolderCompanyName}
            validationMessages={companyNameValidationMessages}
            type="text"
            name={props.externalITProvider._id + '_companyName'}
            value={props.externalITProvider.companyName}
            onChange={props.onInputChange}
          />
          <Input
            labelName={props.labelFirstName}
            inputStyle="input-card"
            labelStyle="label-input-company"
            placeHolder={props.placeHolderFirstName}
            validationMessages={props.validationMessages[props.externalITProvider._id + '_firstName']}
            type="text"
            name={props.externalITProvider._id + '_firstName'}
            value={props.externalITProvider.firstName}
            onChange={props.onInputChange}
          />
          <Input
            labelName={props.labelLastName}
            inputStyle="input-card"
            labelStyle="label-input-company"
            placeHolder={props.placeHolderLastName}
            validationMessages={props.validationMessages[props.externalITProvider._id + '_lastName']}
            type="text"
            name={props.externalITProvider._id + '_lastName'}
            value={props.externalITProvider.lastName}
            onChange={props.onInputChange}
          />
          <Input
            labelName={props.labelPhoneNumber}
            inputStyle="input-card"
            labelStyle="label-input-company"
            placeHolder={props.placeHolderPhoneNumber}
            validationMessages={props.validationMessages[props.externalITProvider._id + '_phoneNumber']}
            type="text"
            name={props.externalITProvider._id + '_phoneNumber'}
            value={props.externalITProvider.phoneNumber}
            onChange={props.onInputChange}
          />
          <Input
            labelName={props.labelEmail}
            inputStyle="input-card"
            labelStyle="label-input-company"
            placeHolder={props.placeHolderEmail}
            validationMessages={props.validationMessages[props.externalITProvider._id + '_email']}
            type="text"
            name={props.externalITProvider._id + '_email'}
            value={props.externalITProvider.email}
            onChange={props.onInputChange}
          />
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/screens/Company/components/ExternalProviders/ExternalProviderCard/ExternalProviderCard.js